// This is for a JS based "embed"
// Below is an example of how this is used:
// <!DOCTYPE html>
// <html lang="en">
//   <head></head>

//   <body>
//     <div
//       id="live-asr-client"
//       data-key="cBTyVHOTEvLbPU8_"
//       data-uppercase="0"
//     ></div>
//     <script src="embed.js"></script>
//   </body>
// </html>

import cssText from "bundle-text:./css/live-asr.scss";

// inject <style> tag
// TODO: Use a shadow DOM to avoid JS and CSS collisions
const styleTag = document.createElement("style");
styleTag.textContent = cssText;
document.head.appendChild(styleTag);

import "./index";
